export const installFormData = self => {
  return {
  size: 'medium',
  span: 24,
  column: 2,
  fields: [
    {
      type: 'default',
      align: 'top',
      justify: 'start',
      __config__: {
        span: 24,
        formId: 'kBORGBaIu',
        layout: 'rowFormItem',
        tagIcon: 'row',
        children: [
          {
            style: {
              width: '100%',
            },
            __slot__: {
              append: '',
              suffix: '',
              prepend: '',
            },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-tree-select',
              _tag: 'a-tree-select',
              span: 24,
              label: '站点名称',
              formId: 'keyZbSPKJ',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'select',
              document: 'https://element.eleme.cn/#/zh-CN/component/select',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'keyZbSPKJ1666260429223',
              showLabel: true,
              renderItem: true,
            },
            options: [],
            __vModel__: 'abodeName',
            placeholder: '请选择站点名称',
            'prefix-icon': '',
            'suffix-icon': '',
            filterable: false,
            multiple: false,
            'show-word-limit': false,
          },
          {
            style: {
              width: '100%',
            },
            __slot__: {
              append: '',
              suffix: '',
              prepend: '',
            },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '项目名称',
              formId: 'kheyLFUJn',
              layout: 'colFormItem',
              regList: [
                {
                  pattern: '/^[\\s\\S]{4,50}$/',
                  message: '长度4到50位字符',
                },
              ],
              tagIcon: 'input',
              document: 'https://element.eleme.cn/#/zh-CN/component/input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'kheyLFUJn1666260318983',
              showLabel: true,
              renderItem: true,
            },
            __vModel__: 'ticketName',
            placeholder: '请输入项目名称',
            'prefix-icon': '',
            'suffix-icon': '',
            __readonly__: {
              span: 1,
            },
            'show-word-limit': false,
          },
          {
            style: {
              width: '100%',
            },
            __slot__: {
              append: '',
              suffix: '',
              prepend: '',
            },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '申请单位',
              formId: 'kheyLFUJn',
              layout: 'colFormItem',
              regList: [
                {
                  pattern: '/^[\\s\\S]{4,200}$/',
                  message: '长度4到200位字符',
                },
              ],
              tagIcon: 'input',
              document: 'https://element.eleme.cn/#/zh-CN/component/input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'kheyLFUJn1666260318983',
              showLabel: true,
              renderItem: true,
            },
            __vModel__: 'applicationName',
            placeholder: '请输入申请单位',
            'prefix-icon': '',
            'suffix-icon': '',
            __readonly__: {
              span: 1,
            },
            'show-word-limit': false,
          },
          {
            style: {
              width: '100%',
            },
            __slot__: {
              append: '',
              suffix: '',
              prepend: '',
            },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '联系人',
              formId: 'keyZbSPKJ',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'input',
              document: 'https://element.eleme.cn/#/zh-CN/component/input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'keyZbSPKJ1666260429223',
              showLabel: true,
              renderItem: true,
            },
            __vModel__: 'name',
            placeholder: '请输入联系人',
            'prefix-icon': '',
            'suffix-icon': '',
            __readonly__: {
              span: 1,
            },
            'show-word-limit': false,
          },
          {
            style: {
              width: '100%',
            },
            __slot__: {
              append: '',
              suffix: '',
              prepend: '',
            },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '联系电话',
              formId: 'kheyLFUJn',
              layout: 'colFormItem',
              regList: [
                {
                  pattern: '/^1(3|4|5|7|8|9)\\d{9}$/',
                  message: '手机号格式错误',
                },
              ],
              tagIcon: 'input',
              document: 'https://element.eleme.cn/#/zh-CN/component/input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'kheyLFUJn1666260318983',
              showLabel: true,
              renderItem: true,
            },
            __vModel__: 'mobile',
            placeholder: '请输入联系电话',
            'prefix-icon': '',
            'suffix-icon': '',
            __readonly__: {
              span: 1,
            },
            'show-word-limit': false,
          },
          {
            style: {
              width: '100%',
            },
            __slot__: {
              append: '',
              suffix: '',
              prepend: '',
            },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '接水地址',
              formId: 'kcCdhvBaq',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'input',
              document: 'https://element.eleme.cn/#/zh-CN/component/input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'kcCdhvBaq1666260428090',
              showLabel: true,
              renderItem: true,
            },
            __vModel__: 'locatedAddress',
            placeholder: '请输入接水地址',
            'prefix-icon': '',
            'suffix-icon': '',
            __readonly__: {
              span: 1,
            },
            'show-word-limit': false,
          },
          {
            style: {
              width: '100%',
            },
            __slot__: {
              append: '',
              suffix: '',
              prepend: '',
            },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '详细地址',
              formId: 'kh1hMiV8G',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'input',
              document: 'https://element.eleme.cn/#/zh-CN/component/input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'kh1hMiV8G1666260426838',
              showLabel: true,
              renderItem: true,
            },
            __vModel__: 'addressDetail',
            placeholder: '请输入详细地址',
            'prefix-icon': '',
            'suffix-icon': '',
            __readonly__: {
              span: 1,
            },
            'show-word-limit': false,
          },
          {
            style: {
              width: '100%',
            },
            __slot__: {
              append: '',
              suffix: '',
              prepend: '',
            },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'el-input',
              span: 24,
              label: '备注',
              type: 'textarea',
              formId: 'kh1hMiV8G',
              layout: 'colFormItem',
              // regList: [
              //   {
              //     message: '请输入正确的身份证号',
              //     pattern:
              //       '/^[1-9]\\d{5}(?:18|19|20)\\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\\d|30|31)\\d{3}[\\dXx]$/',
              //   },
              // ],
              tagIcon: 'input',
              document: 'https://element.eleme.cn/#/zh-CN/component/input',
              // required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'kh1hMiV8G1666260426838',
              showLabel: true,
              renderItem: true,
            },
            __vModel__: 'intro',
            placeholder: '请输入备注',
            'prefix-icon': '',
            'suffix-icon': '',
            __readonly__: {
              span: 1,
            },
            'show-word-limit': false,
          },
        ],
        document:
          'https://element.eleme.cn/#/zh-CN/component/layout#row-attributes',
        renderKey: 'kBORGBaIu1666260315496',
        layoutTree: true,
        componentName: 'row_kBORGBaIu',
      },
    },
    {
      type: 'default',
      align: 'top',
      justify: 'start',
      __config__: {
        span: 24,
        formId: 'kaxkjJOBS',
        layout: 'rowFormItem',
        tagIcon: 'row',
        children: [
          {
            name: 'file',
            accept: 'image/*',
            __slot__: {
              'list-type': true,
            },
            disabled: false,
            multiple: false,
            'list-type': 'text',
            __config__: {
              tag: 'el-upload',
              _tag: 'a-upload',
              span: 24,
              label: '户主身份证头像面',
              formId: 'kWj3j5msf',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'upload',
              document: 'https://element.eleme.cn/#/zh-CN/component/upload',
              fileSize: 30,
              required: true,
              showItem: true,
              sizeUnit: 'MB',
              changeTag: true,
              renderKey: 'kWj3j5msf1666260452025',
              showLabel: true,
              buttonText: '点击上传',
              // notify: '提示： 需上传房主身份证照片、购房合同、开户通知单照片',
              renderItem: true,
            },
            __vModel__: 'idCardF',
            buttonText: '',
            'auto-upload': true,
            placeholder: '请上传户主身份证头像面',
            __readonly__: {
              span: 2,
            },
            uploadNumber: 6,
          },
          {
            name: 'file',
            accept: 'image/*',
            __slot__: {
              'list-type': true,
            },
            disabled: false,
            multiple: false,
            'list-type': 'text',
            __config__: {
              tag: 'el-upload',
              _tag: 'a-upload',
              span: 24,
              label: '户主身份证国徽面',
              formId: 'kWj3j5msf',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'upload',
              document: 'https://element.eleme.cn/#/zh-CN/component/upload',
              fileSize: 30,
              required: true,
              showItem: true,
              sizeUnit: 'MB',
              changeTag: true,
              renderKey: 'kWj3j5msf1666260452025',
              showLabel: true,
              buttonText: '点击上传户主身份证国徽面',
              // notify: '提示： 需上传房主身份证照片、购房合同、开户通知单照片',
              renderItem: true,
            },
            __vModel__: 'idCardB',
            buttonText: '',
            'auto-upload': true,
            placeholder: '请上传户主身份证国徽面',
            __readonly__: {
              span: 2,
            },
            uploadNumber: 6,
          },
          {
            name: 'file',
            accept: 'image/*',
            __slot__: {
              'list-type': true,
            },
            disabled: false,
            multiple: false,
            'list-type': 'text',
            __config__: {
              tag: 'el-upload',
              _tag: 'a-upload',
              span: 24,
              label: '产权证明（规划许可证、土地证、房产证）',
              formId: 'kWj3j5msf',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'upload',
              document: 'https://element.eleme.cn/#/zh-CN/component/upload',
              fileSize: 30,
              required: true,
              showItem: true,
              sizeUnit: 'MB',
              changeTag: true,
              renderKey: 'kWj3j5msf1666260452025',
              showLabel: true,
              buttonText: '点击上传',
              // notify: '提示： 需上传房主身份证照片、购房合同、开户通知单照片',
              renderItem: true,
            },
            __vModel__: 'materials',
            buttonText: '',
            'auto-upload': true,
            placeholder: '请上传产权证明（规划许可证、土地证、房产证）',
            __readonly__: {
              span: 2,
            },
            uploadNumber: 6,
          },
        ],
        document:
          'https://element.eleme.cn/#/zh-CN/component/layout#row-attributes',
        renderKey: 'kaxkjJOBS1666260316646',
        layoutTree: true,
        componentName: 'row_kaxkjJOBS',
      },
    },
  ],
  gutter: 15,
  formRef: 'elForm',
  disabled: false,
  formBtns: true,
  readonly: false,
  formModel: 'formData',
  formRules: 'rules',
  labelWidth: 100,
  labelPosition: 'right',
  __methods__: {
    // tree-select 选择变化事件处理
    change(event) {
      // event 可能是普通值，也可能是包含 label 和 value 的对象
      // 如果是 tree-select 组件，event 会是 { label: 'xxx', value: 'xxx' } 格式
      if (
        event &&
        typeof event === 'object' &&
        event.label !== undefined &&
        event.value !== undefined
      ) {
        // 这是 tree-select 的 change 事件，包含 label 和 value
        // 通过 $parent 访问父组件（InstallWater.vue）的方法
        if (
          this.$parent &&
          typeof this.$parent.handleTreeSelectChange === 'function'
        ) {
          this.$parent.handleTreeSelectChange(event);
        }
      }
    },
  },
  }
}

